import { Trash2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { UserAvatar } from '@/components/ui/UserAvatar'

export interface CollaboratorEntry {
  id: string
  userId: string
  name: string
  initials: string
  role: 'owner' | 'collaborator'
  avatarSeed?: string | null
}

interface CollaboratorListProps {
  collaborators: Array<CollaboratorEntry>
  onRemove?: (collaboratorId: string) => void
  showHeader?: boolean
  className?: string
}

export function CollaboratorList({
  collaborators,
  onRemove,
  showHeader = false,
  className,
}: CollaboratorListProps) {
  if (collaborators.length === 0) return null

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {showHeader && (
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
          Team members
        </span>
      )}
      <div className="flex flex-col gap-1">
        {collaborators.map((collab) => {
          return (
            <div key={collab.id} className="flex items-center justify-between py-1.5">
              <div className="flex items-center gap-2.5 min-w-0">
                <UserAvatar
                  size="xs"
                  initials={collab.initials}
                  name={collab.name}
                />
                <span className="text-sm text-foreground truncate">{collab.name}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm text-muted-foreground">
                  {collab.role === 'owner' ? 'Owner' : 'Collaborator'}
                </span>
                {collab.role !== 'owner' && onRemove && (
                  <button
                    type="button"
                    onClick={() => onRemove(collab.id)}
                    className="text-muted-foreground hover:text-destructive transition-colors p-0.5"
                  >
                    <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
